var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jbsmall_button",style:(_vm.style),on:{"click":function($event){$event.preventDefault();return _vm.do_click()}}},[_vm._t("default",function(){return [_vm._v("click me")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }